/**
 * Dynamic Our Brands menu — loads brands from live collection filters
 * (custom.brand) so only brands with products appear, and new brands show
 * automatically when products are added.
 */
(function () {
  var F_BRAND = 'filter.p.m.custom.brand';
  var CACHE_KEY = 'koni_brands_menu_v1';
  var CACHE_TTL_MS = 60 * 60 * 1000;
  var FINDER_HANDLES = [
    'all',
    'all-products',
    'vehicle-finder-a-brands',
    'vehicle-finder-b-c-brands',
    'vehicle-finder-d-l-brands',
    'vehicle-finder-m-brands',
    'vehicle-finder-n-r-brands',
    'vehicle-finder-s-brands',
    'vehicle-finder-t-brands',
    'vehicle-finder-v-w-brands',
  ];

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.brands) || !parsed.ts) return null;
      if (Date.now() - parsed.ts > CACHE_TTL_MS) return null;
      return parsed.brands;
    } catch (e) {
      return null;
    }
  }

  function writeCache(brands) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), brands: brands }));
    } catch (e) {}
  }

  function handleize(str) {
    return String(str || '')
      .toLowerCase()
      .trim()
      .replace(/['']/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function collectionHandleForBrand(brand) {
    var letter = String(brand || '').charAt(0).toUpperCase();
    var map = {
      A: 'vehicle-finder-a-brands',
      B: 'vehicle-finder-b-c-brands',
      C: 'vehicle-finder-b-c-brands',
      D: 'vehicle-finder-d-l-brands',
      E: 'vehicle-finder-d-l-brands',
      F: 'vehicle-finder-d-l-brands',
      G: 'vehicle-finder-d-l-brands',
      H: 'vehicle-finder-d-l-brands',
      I: 'vehicle-finder-d-l-brands',
      J: 'vehicle-finder-d-l-brands',
      K: 'vehicle-finder-d-l-brands',
      L: 'vehicle-finder-d-l-brands',
      M: 'vehicle-finder-m-brands',
      N: 'vehicle-finder-n-r-brands',
      O: 'vehicle-finder-n-r-brands',
      P: 'vehicle-finder-n-r-brands',
      Q: 'vehicle-finder-n-r-brands',
      R: 'vehicle-finder-n-r-brands',
      S: 'vehicle-finder-s-brands',
      T: 'vehicle-finder-t-brands',
      V: 'vehicle-finder-v-w-brands',
      W: 'vehicle-finder-v-w-brands',
    };
    return map[letter] || 'all';
  }

  function brandUrl(brand, roots) {
    var handle = collectionHandleForBrand(brand);
    var base = (roots && roots[handle]) || '/collections/' + handle;
    return base + '?filter.p.m.custom.brand=' + encodeURIComponent(brand);
  }

  function extractBrandsFromHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.getElementById('koni-brand-filter-data') || doc.getElementById('koni-filter-data');
    if (el) {
      try {
        var parsed = JSON.parse(el.textContent);
        if (parsed && Array.isArray(parsed.brands)) {
          return parsed.brands.filter(Boolean);
        }
        if (Array.isArray(parsed)) {
          for (var i = 0; i < parsed.length; i++) {
            var f = parsed[i];
            if (f && (f.param_name === F_BRAND || f.id === F_BRAND) && Array.isArray(f.values)) {
              return f.values
                .filter(function (v) {
                  return v && (v.count === undefined || v.count > 0);
                })
                .map(function (v) {
                  return v.label || v.value;
                })
                .filter(Boolean);
            }
          }
        }
      } catch (e) {}
    }

    var brands = [];
    var seen = {};
    var inputs = doc.querySelectorAll('input[type="checkbox"][name="' + F_BRAND + '"]');
    inputs.forEach(function (input) {
      var val = (input.value || '').trim();
      if (!val || seen[val]) return;
      seen[val] = true;
      brands.push(val);
    });
    return brands;
  }

  async function fetchBrandsForHandle(handle) {
    var urls = [
      '/collections/' + handle + '?section_id=koni-brand-filters',
      '/collections/' + handle + '?section_id=main',
      '/collections/' + handle + '?section_id=main-collection-product-grid',
      '/collections/' + handle,
    ];
    for (var i = 0; i < urls.length; i++) {
      try {
        var resp = await fetch(urls[i], { credentials: 'same-origin' });
        if (!resp.ok) continue;
        var brands = extractBrandsFromHtml(await resp.text());
        if (brands && brands.length) return brands;
      } catch (e) {}
    }
    return [];
  }

  async function loadAllBrands() {
    var cached = readCache();
    if (cached && cached.length) return cached;

    var map = {};
    // Prefer one "all" request first; fall back to letter collections.
    var primary = await fetchBrandsForHandle('all');
    if (!primary.length) {
      primary = await fetchBrandsForHandle('all-products');
    }
    primary.forEach(function (b) {
      map[b] = true;
    });

    if (Object.keys(map).length < 5) {
      var results = await Promise.all(
        FINDER_HANDLES.filter(function (h) {
          return h !== 'all' && h !== 'all-products';
        }).map(fetchBrandsForHandle)
      );
      results.forEach(function (list) {
        list.forEach(function (b) {
          map[b] = true;
        });
      });
    }

    var brands = Object.keys(map).sort(function (a, b) {
      return a.localeCompare(b, undefined, { sensitivity: 'base' });
    });
    if (brands.length) writeCache(brands);
    return brands;
  }

  function logoSrc(brand, cfg) {
    var handle = handleize(brand);
    if (cfg.overrides && cfg.overrides[handle]) return cfg.overrides[handle];
    if (cfg.cdnBase) return cfg.cdnBase + 'brand-' + handle + '.jpg';
    if (cfg.assetBase) return cfg.assetBase + 'brand-' + handle + '.jpg';
    return '';
  }

  function renderBrandItem(brand, cfg) {
    var letter = brand.charAt(0).toUpperCase();
    var src = logoSrc(brand, cfg);
    var logoHtml;
    if (src) {
      logoHtml =
        '<img class="koni-brands-menu__logo-img" src="' +
        src +
        '" alt="" width="28" height="28" loading="lazy" onerror="this.classList.add(\'is-hidden\');this.nextElementSibling.classList.remove(\'is-hidden\');">' +
        '<span class="koni-brands-menu__initial is-hidden">' +
        letter +
        '</span>';
    } else {
      logoHtml = '<span class="koni-brands-menu__initial">' + letter + '</span>';
    }

    return (
      '<a href="' +
      brandUrl(brand, cfg.collectionUrls) +
      '" class="koni-brands-menu__item">' +
      '<span class="koni-brands-menu__logo" aria-hidden="true">' +
      logoHtml +
      '</span>' +
      '<span class="koni-brands-menu__name">' +
      brand.replace(/</g, '&lt;') +
      '</span>' +
      '</a>'
    );
  }

  function renderColumns(brands, cfg) {
    var groups = {};
    brands.forEach(function (brand) {
      var letter = brand.charAt(0).toUpperCase();
      if (!groups[letter]) groups[letter] = [];
      groups[letter].push(brand);
    });

    var letters = Object.keys(groups).sort();
    return letters
      .map(function (letter) {
        var items = groups[letter].map(function (b) {
          return renderBrandItem(b, cfg);
        }).join('');
        return (
          '<div class="koni-brands-menu__group">' +
          '<p class="koni-brands-menu__letter">' +
          letter +
          '</p>' +
          items +
          '</div>'
        );
      })
      .join('');
  }

  function readConfig(root) {
    var cfg = {
      overrides: {},
      cdnBase: root.getAttribute('data-logo-cdn') || '',
      assetBase: root.getAttribute('data-asset-base') || '',
      collectionUrls: {},
      countTemplate: root.getAttribute('data-count-template') || '__COUNT__ manufacturers · A–Z',
    };
    var overridesEl = root.querySelector('[data-koni-brand-logo-overrides]');
    if (overridesEl) {
      try {
        cfg.overrides = JSON.parse(overridesEl.textContent) || {};
      } catch (e) {}
    }
    var urlsEl = root.querySelector('[data-koni-collection-urls]');
    if (urlsEl) {
      try {
        cfg.collectionUrls = JSON.parse(urlsEl.textContent) || {};
      } catch (e) {}
    }
    return cfg;
  }

  async function initMenu(root) {
    if (!root || root.dataset.koniBrandsReady === '1') return;
    root.dataset.koniBrandsReady = '1';

    var columns = root.querySelector('[data-koni-brands-columns]');
    var countEl = root.querySelector('[data-koni-brands-count]');
    if (!columns) return;

    columns.setAttribute('aria-busy', 'true');
    var cfg = readConfig(root);

    try {
      var brands = await loadAllBrands();
      if (!brands.length) {
        columns.setAttribute('aria-busy', 'false');
        return;
      }
      columns.innerHTML = renderColumns(brands, cfg);
      if (countEl) {
        countEl.textContent = cfg.countTemplate
          .replace('__COUNT__', String(brands.length))
          .replace('{{ count }}', String(brands.length));
      }
      root.classList.add('koni-brands-menu--dynamic-ready');
    } catch (e) {
      console.warn('[Koni] brands menu load failed:', e);
    } finally {
      columns.setAttribute('aria-busy', 'false');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-koni-brands-menu]').forEach(function (el) {
      initMenu(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
